<ng-container *transloco="let t">
  <div
    class="map-container"
    leaflet
    [leafletOptions]="options"
    [leafletLayers]="mapLayers"
    (leafletMapReady)="onMapReady($event)"
    (leafletClick)="onMapClick($event)"
  ></div>
  <div
    class="overlay-container"
    [style.transform]="
      isMobileView ? 'translateY(' + sheetTransformY + ')' : 'none'
    "
    [style.transition]="
      !isDragging
        ? 'transform ' + bottomSheetConfig.animationDuration + 'ms ease'
        : 'none'
    "
    (touchstart)="onDragStart($event)"
    (touchmove)="onDragMove($event)"
    (touchend)="onDragEnd($event)"
    (mousedown)="onDragStart($event)"
    (mousemove)="onDragMove($event)"
    (mouseup)="onDragEnd($event)"
  >
    <div
      class="cards-group"
      [@cardGroupAnimation]="getCardGroupState('blankLoading')"
    >
      <p-skeleton
        class="skeleton-loader no-padding"
        height="500px"
        width="100%"
      />
    </div>

    <div
      class="cards-group"
      [@cardGroupAnimation]="getCardGroupState('selectedStationWithBikes')"
    >
      <div class="back-button" pRipple (click)="onCardGroupBack()">
        <span class="material-symbols-outlined chevron">
          chevron_backward
        </span>
        <span class="destination">{{ t("stationsList") }}</span>
      </div>
      <ng-container [ngTemplateOutlet]="reportFloatingBtn"></ng-container>
      <ng-container [ngTemplateOutlet]="selectedStationTmpl"></ng-container>
      <ng-container [ngTemplateOutlet]="bikesListTmpl"></ng-container>
    </div>

    <div
      class="cards-group"
      [@cardGroupAnimation]="getCardGroupState('stationsList')"
    >
      <ng-container [ngTemplateOutlet]="reportFloatingBtn"></ng-container>
      <ng-container [ngTemplateOutlet]="stationsListTmpl"></ng-container>
    </div>

    <div
      class="cards-group"
      [@cardGroupAnimation]="getCardGroupState('selectedBike')"
    >
      <ng-container [ngTemplateOutlet]="reportFloatingBtn"></ng-container>
      <div class="back-button" pRipple (click)="onCardGroupBack()">
        <span class="material-symbols-outlined chevron">
          chevron_backward
        </span>
        <span class="destination">{{ t("bikesList") }}</span>
      </div>
      <ng-container [ngTemplateOutlet]="selectedBikeTmpl"> </ng-container>
      <ng-container [ngTemplateOutlet]="tariffPlansTmpl"> </ng-container>
    </div>

    <div
      class="cards-group"
      [@cardGroupAnimation]="getCardGroupState('arrivalStationsList')"
    >
      <div class="back-button" pRipple (click)="onCardGroupBack()">
        <span class="material-symbols-outlined chevron">
          chevron_backward
        </span>
        <span class="destination">{{ t("tariffPlans") }}</span>
      </div>
      <ng-container [ngTemplateOutlet]="reportFloatingBtn"></ng-container>
      <ng-container [ngTemplateOutlet]="arrivalStationsListTmpl"></ng-container>
    </div>

    <div
      class="cards-group"
      [@cardGroupAnimation]="getCardGroupState('selectionResume')"
    >
      <ng-container [ngTemplateOutlet]="reportFloatingBtn"></ng-container>
      <div class="back-button" pRipple (click)="onCardGroupBack()">
        <span class="material-symbols-outlined chevron">
          chevron_backward
        </span>
        <span class="destination">{{ t("arrivalStation") }}</span>
      </div>
      <ng-container [ngTemplateOutlet]="selectionResumeTmpl"> </ng-container>
    </div>

    <div
      class="cards-group"
      [@cardGroupAnimation]="getCardGroupState('paymentMethods')"
    >
      <ng-container [ngTemplateOutlet]="reportFloatingBtn"></ng-container>
      <ng-container [ngTemplateOutlet]="paymentMethodsTmpl"></ng-container>
    </div>

    <div
      class="cards-group"
      [@cardGroupAnimation]="getCardGroupState('bikeUnlock')"
    >
      <ng-container [ngTemplateOutlet]="reportFloatingBtn"></ng-container>
      <ng-container [ngTemplateOutlet]="bikeUnlockTmpl"></ng-container>
    </div>

    <div class="cards-group" [@cardGroupAnimation]="getCardGroupState('ride')">
      <ng-container [ngTemplateOutlet]="reportFloatingBtn"></ng-container>
      <ng-container [ngTemplateOutlet]="rideTmpl"></ng-container>
    </div>

    <div
      class="cards-group"
      [@cardGroupAnimation]="getCardGroupState('changeArrivalStationsList')"
    >
      <div class="back-button" pRipple (click)="onCardGroupBack()">
        <span class="material-symbols-outlined chevron">
          chevron_backward
        </span>
        <span class="destination">{{ t("ride") }}</span>
      </div>
      <ng-container [ngTemplateOutlet]="reportFloatingBtn"></ng-container>
      <ng-container
        [ngTemplateOutlet]="changeArrivalStationsListTmpl"
      ></ng-container>
    </div>
  </div>

  <ng-template #selectedStationTmpl>
    @if (selectedStation && !((selectedStationLoadingUI$ | async) ?? true)) {
      <div class="section-card no-border" id="selected-station">
        @if (selectedStation.outsidePicture) {
          <div class="card-full-header">
            <img
              [src]="'/assets/stations/' + selectedStation.outsidePicture"
              [alt]="t('stationPicture')"
              class="header-image"
            />
          </div>
        } @else {
          <p class="card-small-title">{{ t("selectedStation") }}</p>
        }

        <p class="card-title">
          @if (selectedStation.logoPicture) {
            <img
              [src]="'/assets/stations/' + selectedStation.logoPicture"
              [alt]="t('stationPicture')"
              class="station-logo"
            />
          }
          {{ selectedStation.description }}
        </p>

        <div class="station-details-container">
          <div
            class="detail-row expandable"
            pRipple
            [class.expanded]="openingTimesExpanded"
            (click)="openingTimesExpanded = !openingTimesExpanded"
          >
            <div class="row-header">
              <span class="material-symbols-outlined detail-icon"
                >schedule</span
              >
              <p class="detail-value station-times">
                <span
                  class="open-status"
                  [class.open]="selectedStation.open"
                  [class.open-soon]="isOpeningSoon(selectedStation)"
                  [class.close-soon]="isClosingSoon(selectedStation)"
                >
                  {{
                    isOpeningSoon(selectedStation)
                      ? t("openingSoon")
                      : isClosingSoon(selectedStation)
                        ? t("closingSoon")
                        : selectedStation.open
                          ? t("open")
                          : t("closed")
                  }}
                </span>
                ⋅
                <span class="time-details">{{
                  getNowOpenTimeSlot(selectedStation)
                }}</span>
              </p>

              <span class="material-symbols-outlined detail-chevron">
                keyboard_arrow_down
              </span>
            </div>
            <div
              class="detail-row-expanded-content"
              [@expandCollapse]="
                openingTimesExpanded ? 'expanded' : 'collapsed'
              "
            >
              <div class="station-times-list">
                @for (day of getDayIndices(); track day) {
                  <div
                    class="day-row"
                    [class.today]="day === getTodayNumber()"
                    [class.open]="selectedStation.open"
                  >
                    <span class="day-name">{{
                      t("primeng.dayNames")[day]
                    }}</span>
                    <p
                      class="day-times"
                      [innerHTML]="t(getDayTimes(selectedStation, day))"
                    ></p>
                  </div>
                }
              </div>
            </div>
          </div>

          <a
            class="detail-row"
            [href]="
              'https://maps.google.com/?q=' +
              selectedStation.lat +
              ',' +
              selectedStation.lng
            "
            target="_blank"
            pRipple
          >
            <span class="material-symbols-outlined detail-icon">
              location_on
            </span>
            <p class="detail-value">
              {{ formatDistance(selectedStation.distance) }}
              ⋅
              {{ getStationAddressString(selectedStation) }}
            </p>
          </a>
        </div>
      </div>
    } @else {
      <p-skeleton
        class="skeleton-loader no-padding"
        height="120px"
        width="100%"
      />
    }
  </ng-template>

  <ng-template #bikesListTmpl>
    <div class="section-card" id="bikes-list">
      <p class="card-small-title">{{ t("availableBikes") }}</p>
      <div class="list-container">
        @if ((bikesLoadingUI$ | async) ?? true) {
          @for (i of [1, 2, 3, 4]; track i) {
            <p-skeleton class="skeleton-loader" height="80px" width="100%" />
          }
        } @else {
          @for (bike of bikes; track bike.bikeId) {
            <div class="bike-item" pRipple (click)="bikeClick(bike)">
              <div class="bike-picture">
                @if (bike.modelDetails?.mainPicture) {
                  <img
                    [src]="
                      '/assets/bike_models/' + bike.modelDetails?.mainPicture
                    "
                    [alt]="t('modelPicture')"
                  />
                } @else {
                  <span class="material-symbols-outlined"> pedal_bike </span>
                }
              </div>

              <div class="bike-details">
                <h3 class="bike-model-name">
                  {{ bike.progressive }} •
                  {{ bike.modelDetails?.description ?? "--" }}
                </h3>

                <p class="bike-identifier">#{{ bike.identifier ?? "--" }}</p>

                <div class="bike-info-container">
                  <div
                    class="bike-info"
                    [pTooltip]="t('maxSpeed')"
                    tooltipPosition="top"
                    [showDelay]="500"
                  >
                    <span class="material-symbols-outlined info-icon">
                      speed
                    </span>
                    <span class="info-value"
                      >{{ bike.modelDetails?.maxSpeed ?? "--" }} km/h</span
                    >
                  </div>

                  <div
                    class="bike-info"
                    [pTooltip]="t('maxDistance')"
                    tooltipPosition="top"
                    [showDelay]="500"
                  >
                    <span class="material-symbols-outlined info-icon">
                      route
                    </span>
                    <span class="info-value"
                      >{{ bike.modelDetails?.maxDistance ?? "--" }} km</span
                    >
                  </div>
                </div>
              </div>

              @if (bike.iotDetails && bike.iotDetails.bike?.battery?.level) {
                <div
                  class="bike-battery"
                  [style.--battery-level]="
                    bike.iotDetails.bike?.battery?.level + '%'
                  "
                  [style.--battery-color]="
                    getBatteryColor(bike.iotDetails.bike?.battery?.level)
                  "
                  [pTooltip]="t('remainingBattery')"
                  tooltipPosition="top"
                  [showDelay]="500"
                  [class.charging]="
                    bike.iotDetails.bike?.battery?.status == 'CHARGING'
                  "
                >
                  <span class="battery-level">{{
                    bike.iotDetails.bike?.battery?.level
                  }}</span>
                </div>
              }
            </div>

            @if (!$last) {
              <div class="sep-line"></div>
            }
          } @empty {
            <div class="data-placeholder">
              <img
                class="illustration"
                src="assets/no-bikes.svg"
                [alt]="t('noResults')"
              />
              <h2>{{ t("noBikesFound") }}</h2>
              <p>{{ t("notFoundChangeParameters") }}</p>
            </div>
          }
        }
      </div>
    </div>
  </ng-template>

  <ng-template #stationsListTmpl>
    <div class="section-card" id="stations-list">
      <p class="card-small-title">
        {{
          currentSearchLocation
            ? t("stationsInSelectedZone")
            : t("stationsNearby")
        }}
      </p>
      <p class="card-title">{{ t("departureStation") }}</p>

      <div class="actions-container">
        <p-button
          icon="pi pi-refresh"
          styleClass="refresh-button"
          [rounded]="true"
          size="small"
          severity="primary"
          [outlined]="true"
          (click)="refreshStations()"
          [disabled]="(stationsLoading$ | async) ?? true"
        />

        <p-button
          [label]="t('filters')"
          icon="pi pi-filter"
          styleClass="filter-button"
          [rounded]="true"
          size="small"
          severity="secondary"
          (click)="showStationsFilters()"
        />

        @if (currentSearchLocation && isGpsAvailable) {
          <p-button
            [label]="t('searchInYourZone')"
            icon="pi pi-bullseye"
            styleClass="change-zone-button"
            [rounded]="true"
            [outlined]="true"
            size="small"
            severity="help"
            (click)="setLockUser(true)"
          />
        } @else {
          <p-button
            [label]="t('searchOnMap')"
            icon="pi pi-map"
            styleClass="search-map-button"
            [rounded]="true"
            [outlined]="true"
            size="small"
            severity="secondary"
            (click)="showAddressSearch()"
          />
        }
      </div>

      <div class="list-container">
        @if ((stationsLoadingUI$ | async) ?? true) {
          @for (i of [1, 2, 3, 4]; track i) {
            <p-skeleton class="skeleton-loader" height="90px" width="100%" />
          }
        } @else {
          @for (station of stations; track station.stationId) {
            <div
              class="station-item"
              pRipple
              (click)="stationClick(station)"
              [class.unavailable]="isStationUnavailable(station)"
              [class.bonus]="station.bonus"
            >
              <div class="station-picture">
                @if (station.logoPicture) {
                  <img
                    [src]="'/assets/stations/' + station.logoPicture"
                    [alt]="t('stationPicture')"
                  />
                } @else {
                  <span class="material-symbols-outlined"> location_on </span>
                }
              </div>

              <div class="station-details">
                <h3 class="station-name">
                  {{ station.description }}
                </h3>

                <p class="station-times">
                  <span
                    class="open-status"
                    [class.open]="station.open"
                    [class.open-soon]="isOpeningSoon(station)"
                    [class.close-soon]="isClosingSoon(station)"
                    >{{
                      isOpeningSoon(station)
                        ? t("openingSoon")
                        : isClosingSoon(station)
                          ? t("closingSoon")
                          : station.open
                            ? t("open")
                            : t("closed")
                    }}</span
                  >
                  ⋅
                  <span class="time-details">{{
                    getNowOpenTimeSlot(station)
                  }}</span>
                </p>

                <!-- <p class="station-address">
                  {{ getStationAddressString(station) }}
                </p> -->

                <div class="station-info-container">
                  <div
                    class="station-info"
                    [pTooltip]="t('distance')"
                    tooltipPosition="top"
                    [showDelay]="500"
                  >
                    <span class="material-symbols-outlined info-icon">
                      distance
                    </span>
                    <span class="info-value">{{
                      formatDistance(station.distance)
                    }}</span>
                  </div>

                  @if (station.open || isOpeningSoon(station)) {
                    <div
                      class="station-info"
                      [pTooltip]="t('availability')"
                      tooltipPosition="top"
                      [showDelay]="500"
                      [class.error]="!station.bikesCount"
                    >
                      <span class="material-symbols-outlined info-icon">
                        pedal_bike
                      </span>
                      <span class="info-value">{{
                        t("availableWithCount", { count: station.bikesCount })
                      }}</span>
                    </div>
                  }
                  @if (station.bonus) {
                    <div
                      class="station-info bonus"
                      [pTooltip]="t('bonus')"
                      tooltipPosition="top"
                      [showDelay]="500"
                    >
                      <span class="material-symbols-outlined info-icon">
                        percent
                      </span>
                      <span class="info-value"
                        >{{ t("discount") + " " + station.bonus }}%</span
                      >
                    </div>
                  }
                </div>
              </div>
            </div>

            @if (!$last) {
              <div class="sep-line"></div>
            }
          } @empty {
            <div class="data-placeholder">
              <img
                class="illustration"
                src="assets/no-location.svg"
                [alt]="t('noResults')"
              />
              <h2>{{ t("noStationsFound") }}</h2>
              <p>
                {{
                  stationsLastReturnCode == 200
                    ? t("noStationAvailableInSelectedArea")
                    : t("notFoundChangeParameters")
                }}
              </p>
            </div>
          }
        }
      </div>
    </div>
  </ng-template>

  <ng-template #selectedBikeTmpl>
    @if (selectedBike && !((selectedBikeLoadingUI$ | async) ?? true)) {
      <div class="section-card" id="selected-bike">
        <!-- <p class="card-small-title">{{ t("selectedBike") }}</p> -->

        <!-- @if (selectedStation) {
        <div class="station-item">
          <div class="station-picture">
            @if (selectedStation.logoPicture) {
              <img
                [src]="'/assets/stations/' + selectedStation.logoPicture"
                [alt]="t('stationPicture')"
              />
            } @else {
              <span class="material-symbols-outlined"> location_on </span>
            }
          </div>

          <div class="station-details">
            <h3 class="station-name">
              {{ selectedStation.description }}
            </h3>

            <p class="station-address">
              {{ getStationAddressString(selectedStation) }}
            </p>
          </div>
        </div>

        <div class="sep-line"></div>
      } -->
        <div class="bike-item">
          <div class="bike-picture">
            @if (selectedBike.modelDetails?.mainPicture) {
              <img
                [src]="
                  '/assets/bike_models/' +
                  selectedBike.modelDetails?.mainPicture
                "
                [alt]="t('modelPicture')"
              />
            } @else {
              <span class="material-symbols-outlined"> pedal_bike </span>
            }
          </div>

          <div class="bike-details">
            <h3 class="bike-model-name">
              {{ selectedBike.progressive }} •
              {{ selectedBike.modelDetails?.description ?? "--" }}
            </h3>
            <p class="bike-codes">
              {{
                t("identifier") +
                  " #" +
                  (selectedBike.identifier ?? selectedBike.bikeId)
              }}
            </p>
          </div>

          @if (
            selectedBike.iotDetails &&
            selectedBike.iotDetails.bike?.battery?.level
          ) {
            <div
              class="bike-battery"
              [style.--battery-level]="
                selectedBike.iotDetails.bike?.battery?.level + '%'
              "
              [style.--battery-color]="
                getBatteryColor(selectedBike.iotDetails.bike?.battery?.level)
              "
              [pTooltip]="t('remainingBattery')"
              tooltipPosition="top"
              [showDelay]="500"
              [class.charging]="
                selectedBike.iotDetails.bike?.battery?.status == 'CHARGING'
              "
            >
              <span class="battery-level">{{
                selectedBike.iotDetails.bike?.battery?.level
              }}</span>
            </div>
          }
        </div>

        <div class="bike-model-details">
          <div class="detail-row">
            <span class="material-symbols-outlined detail-icon"> speed </span>
            <p class="detail-label">{{ t("maxSpeed") }}</p>

            <div class="detail-value-container">
              <p class="detail-value">
                {{ selectedBike.modelDetails?.maxSpeed ?? "--" }} km/h
              </p>
            </div>
          </div>

          <div class="detail-row">
            <span class="material-symbols-outlined detail-icon"> route </span>
            <p class="detail-label">{{ t("maxDistance") }}</p>

            <div class="detail-value-container">
              <p class="detail-value">
                {{ selectedBike.modelDetails?.maxDistance ?? "--" }} km
              </p>
            </div>
          </div>

          <div class="detail-row">
            <span class="material-symbols-outlined detail-icon">
              electric_bike
            </span>
            <p class="detail-label">{{ t("residualAutonomy") }}</p>

            <div class="detail-value-container">
              <p class="detail-value">
                @if (selectedBike.iotDetails?.bike?.battery?.level) {
                  {{ selectedBike.iotDetails?.bike?.battery?.level ?? "--" }}%
                  (~
                  {{
                    ((selectedBike.iotDetails?.bike?.battery?.level ?? 0) *
                      (selectedBike.modelDetails?.maxDistance ?? 0)) /
                      100
                  }}
                  km)
                } @else {
                  {{ t("notAvailableShort") }}
                }
              </p>
            </div>
          </div>
        </div>
      </div>
    } @else {
      <p-skeleton
        class="skeleton-loader no-padding"
        height="180px"
        width="100%"
      />
    }
  </ng-template>

  <ng-template #tariffPlansTmpl>
    @if (selectedBike) {
      <div class="section-card" id="tariff-plans-list">
        <p class="card-small-title">{{ t("selectTariffPlan") }}</p>

        <div class="list-container">
          @if ((selectedBikeLoadingUI$ | async) ?? true) {
            @for (i of [1, 2]; track i) {
              <p-skeleton class="skeleton-loader" height="90px" width="100%" />
            }
          } @else {
            @for (plan of selectedBike.tariffPlans; track plan.planId) {
              <div
                class="tariff-plan-item"
                pRipple
                (click)="planClick(plan)"
                (contextmenu)="
                  $event.preventDefault(); showTariffPlanInfo(plan)
                "
                (longPress)="showTariffPlanInfo(plan)"
                appLongPress
              >
                <div class="tariff-plan-details">
                  <h3 class="tariff-plan-name">
                    {{ plan.description }}
                  </h3>

                  <div class="tariff-plan-info-container">
                    <div
                      class="plan-info"
                      [pTooltip]="t('unlockCost')"
                      tooltipPosition="top"
                      [showDelay]="500"
                    >
                      <span class="material-symbols-outlined info-icon">
                        lock_open
                      </span>
                      <span class="info-value" [class.green]="!plan.unlockCost">
                        @if (plan.unlockCost) {
                          {{ plan.unlockCost }} €
                        } @else {
                          {{ t("free") }}
                        }
                      </span>
                    </div>

                    @if (plan.maxRideDuration) {
                      <div
                        class="plan-info"
                        [pTooltip]="t('maxRideDuration')"
                        tooltipPosition="top"
                        [showDelay]="500"
                      >
                        <span class="material-symbols-outlined info-icon">
                          timer
                        </span>
                        <span class="info-value">
                          {{ plan.maxRideDuration }} min max
                        </span>
                      </div>
                    }

                    @if (plan.maxRideDistance) {
                      <div
                        class="plan-info"
                        [pTooltip]="t('maxRideDistance')"
                        tooltipPosition="top"
                        [showDelay]="500"
                      >
                        <span class="material-symbols-outlined info-icon">
                          route
                        </span>
                        <span class="info-value">
                          {{ plan.maxRideDistance }} km max
                        </span>
                      </div>
                    }
                  </div>
                  <!-- @if (plan.unlockCost) {
                <p class="tariff-plan-unlock">
                  {{ t("unlockCostLabel", { cost: plan.unlockCost }) }}
                </p>
              } @else {
                <p class="tariff-plan-unlock free">
                  {{ t("freeUnlock") }}
                </p>
              } -->
                </div>
                <div class="tariff-plan-pricing">
                  @if (plan.kmCost) {
                    <span class="recurring-price"
                      >€{{ plan.kmCost }}<span class="unit">/km</span></span
                    >
                    @if (plan.freeKm) {
                      <span class="free-offer">
                        {{ t("freeKmOffer", { km: plan.freeKm }) }}
                      </span>
                    }
                  } @else {
                    <span class="recurring-price"
                      >€{{ plan.minCost }}<span class="unit">/min</span></span
                    >
                    @if (plan.freeMins) {
                      <span class="free-offer">
                        {{ t("freeMinsOffer", { mins: plan.freeMins }) }}
                      </span>
                    }
                  }
                </div>
                <div
                  class="tariff-plan-info-btn"
                  (click)="
                    $event.preventDefault();
                    $event.stopPropagation();
                    showTariffPlanInfo(plan)
                  "
                >
                  <span class="material-symbols-outlined"> info </span>
                </div>
              </div>

              @if (!$last) {
                <div class="sep-line"></div>
              }
            }
          }
        </div>
      </div>
    } @else {}
  </ng-template>

  <ng-template #arrivalStationsListTmpl>
    <div class="section-card" id="arrival-stations-list">
      <p class="card-small-title">
        {{
          currentSearchLocation
            ? t("stationsInSelectedZone")
            : t("stationsNearby")
        }}
      </p>
      <p class="card-title">{{ t("arrivalStation") }}</p>

      <div class="actions-container">
        <p-button
          icon="pi pi-refresh"
          styleClass="refresh-button"
          [rounded]="true"
          size="small"
          severity="primary"
          [outlined]="true"
          (click)="refreshArrivalStations()"
          [disabled]="(arrivalStationsLoading$ | async) ?? true"
        />

        <p-button
          [label]="t('filters')"
          icon="pi pi-filter"
          styleClass="filter-button"
          [rounded]="true"
          size="small"
          severity="secondary"
          (click)="showArrivalStationsFilters()"
        />

        @if (currentSearchLocation && isGpsAvailable) {
          <p-button
            [label]="t('searchInYourZone')"
            icon="pi pi-bullseye"
            styleClass="change-zone-button"
            [rounded]="true"
            [outlined]="true"
            size="small"
            severity="help"
            (click)="setLockUser(true)"
          />
        } @else {
          <p-button
            [label]="t('searchOnMap')"
            icon="pi pi-map"
            styleClass="search-map-button"
            [rounded]="true"
            [outlined]="true"
            size="small"
            severity="secondary"
            (click)="showAddressSearch()"
          />
        }
      </div>

      <div class="list-container">
        @if ((arrivalStationsLoadingUI$ | async) ?? true) {
          @for (i of [1, 2, 3, 4]; track i) {
            <p-skeleton class="skeleton-loader" height="90px" width="100%" />
          }
        } @else {
          @for (station of arrivalStations; track station.stationId) {
            <div
              class="station-item"
              pRipple
              (click)="arrivalStationClick(station)"
              [class.unavailable]="isArrivalStationUnavailable(station)"
              [class.bonus]="station.bonus"
              [class.same-as-departure]="
                station.stationId === selectedStation?.stationId
              "
            >
              <div class="station-picture">
                @if (station.logoPicture) {
                  <img
                    [src]="'/assets/stations/' + station.logoPicture"
                    [alt]="t('stationPicture')"
                  />
                } @else {
                  <span class="material-symbols-outlined"> location_on </span>
                }
              </div>

              <div class="station-details">
                <h3 class="station-name">
                  {{ station.description }}
                </h3>

                <p class="station-times">
                  <span
                    class="open-status"
                    [class.open]="station.open"
                    [class.open-soon]="isOpeningSoon(station)"
                    [class.close-soon]="isClosingSoon(station)"
                    >{{
                      isOpeningSoon(station)
                        ? t("openingSoon")
                        : isClosingSoon(station)
                          ? t("closingSoon")
                          : station.open
                            ? t("open")
                            : t("closed")
                    }}</span
                  >
                  ⋅
                  <span class="time-details">{{
                    getNowOpenTimeSlot(station)
                  }}</span>
                </p>

                <!-- <p class="station-address">
                  {{ getStationAddressString(station) }}
                </p> -->

                <div class="station-info-container">
                  <div
                    class="station-info"
                    [pTooltip]="t('distance')"
                    tooltipPosition="top"
                    [showDelay]="500"
                  >
                    <span class="material-symbols-outlined info-icon">
                      distance
                    </span>
                    <span class="info-value">{{
                      formatDistance(station.distance)
                    }}</span>
                  </div>

                  @if (station.bonus) {
                    <div
                      class="station-info bonus"
                      [pTooltip]="t('bonus')"
                      tooltipPosition="top"
                      [showDelay]="500"
                    >
                      <span class="material-symbols-outlined info-icon">
                        percent
                      </span>
                      <span class="info-value"
                        >{{ t("discount") + " " + station.bonus }}%</span
                      >
                    </div>
                  }
                </div>
              </div>
            </div>

            @if (!$last) {
              <div class="sep-line"></div>
            }
          } @empty {
            <div class="data-placeholder">
              <img
                class="illustration"
                src="assets/no-location.svg"
                [alt]="t('noResults')"
              />
              <h2>{{ t("noStationsFound") }}</h2>
              <p>
                {{
                  stationsLastReturnCode == 200
                    ? t("noStationAvailableInSelectedArea")
                    : t("notFoundChangeParameters")
                }}
              </p>
            </div>
          }
        }
      </div>
    </div>
  </ng-template>

  <ng-template #reportFloatingBtn>
    <div class="report-floating-btn" (click)="showReportDialog()">
      <span class="material-symbols-outlined"> flag </span>
    </div>
  </ng-template>

  <ng-template #selectionResumeTmpl>
    <div class="section-card" id="selection-resume">
      <p class="card-small-title">{{ t("selectionResume") }}</p>

      @if (selectedStation) {
        <div class="station-item" [class.bonus]="selectedStation.bonus">
          <div class="station-picture departure">
            @if (selectedStation.logoPicture) {
              <img
                [src]="'/assets/stations/' + selectedStation.logoPicture"
                [alt]="t('stationPicture')"
              />
            } @else {
              <span class="material-symbols-outlined"> play_arrow </span>
            }
          </div>

          <div class="station-details">
            <h3 class="station-name">
              {{ selectedStation.description }}
            </h3>

            <p class="station-address">
              {{ getStationAddressString(selectedStation) }}
            </p>
          </div>
        </div>

        @if (selectedArrivalStation) {
          <span class="material-symbols-outlined arrow"> south </span>
          <div
            class="station-item"
            [class.bonus]="selectedArrivalStation.bonus"
          >
            <div class="station-picture arrival">
              @if (selectedArrivalStation.logoPicture) {
                <img
                  [src]="
                    '/assets/stations/' + selectedArrivalStation.logoPicture
                  "
                  [alt]="t('stationPicture')"
                />
              } @else {
                <span class="material-symbols-outlined"> sports_score </span>
              }
            </div>

            <div class="station-details">
              <h3 class="station-name">
                {{ selectedArrivalStation.description }}
              </h3>

              <p class="station-address">
                {{ getStationAddressString(selectedArrivalStation) }}
              </p>
            </div>
          </div>
        }

        <div class="sep-line"></div>
      }

      @if (selectedBike) {
        <div class="bike-item">
          <div class="bike-picture">
            @if (selectedBike.modelDetails?.mainPicture) {
              <img
                [src]="
                  '/assets/bike_models/' +
                  selectedBike.modelDetails?.mainPicture
                "
                [alt]="t('modelPicture')"
              />
            } @else {
              <span class="material-symbols-outlined"> pedal_bike </span>
            }
          </div>

          <div class="bike-details">
            <h3 class="bike-model-name">
              {{ selectedBike.progressive }} •
              {{ selectedBike.modelDetails?.description ?? "--" }}
            </h3>
            <p class="bike-codes">
              {{
                t("identifier") +
                  " #" +
                  (selectedBike.identifier ?? selectedBike.bikeId)
              }}
            </p>
          </div>
        </div>
        <div class="sep-line"></div>
      }

      @if (selectedTariffPlan) {
        <div class="tariff-plan-item">
          <div class="tariff-plan-icon">
            <span class="material-symbols-outlined"> payments </span>
          </div>

          <div class="tariff-plan-details">
            <h3 class="tariff-plan-name">
              {{ selectedTariffPlan.description }}
            </h3>

            <p class="tariff-plan-extra-details">{{ t("tariffPlan") }}</p>
          </div>

          <div
            class="tariff-plan-info-btn"
            (click)="
              $event.preventDefault();
              $event.stopPropagation();
              showTariffPlanInfo(selectedTariffPlan)
            "
          >
            <span class="material-symbols-outlined"> info </span>
          </div>
        </div>

        <!-- <div class="sep-line"></div> -->
      }

      <div class="confirm-button" pRipple (click)="confirmRideClick()">
        {{ t("confirmAndGoToPayment") }}
      </div>
      <p
        class="helper-text helper-text-link"
        [innerHTML]="t('rideConfirmationHelper')"
      ></p>
    </div>
  </ng-template>

  <ng-template #paymentMethodsTmpl>
    <div class="section-card" id="payment-methods">
      <p class="card-small-title">{{ t("payment") }}</p>

      <div class="payment-details">
        <div class="detail-row">
          <span class="material-symbols-outlined detail-icon"> savings </span>
          <p class="detail-label">{{ t("preauthorization") }}</p>

          <div class="detail-value-container">
            <p class="detail-value">
              {{ currentRideData?.preauthorizedAmount ?? "--" }} €
            </p>
          </div>
        </div>

        <div class="detail-row">
          <span class="material-symbols-outlined detail-icon"> loyalty </span>
          <p class="detail-label">{{ t("discounts") }}</p>

          <div class="detail-value-container">
            <p class="detail-value">--</p>
          </div>
        </div>

        <div class="sep-line total-line"></div>
        <div class="detail-row total">
          <p class="detail-label">{{ t("total") }}</p>

          <div class="detail-value-container">
            <p class="detail-value">
              {{ currentRideData?.preauthorizedAmount ?? "--" }} €
            </p>
          </div>
        </div>
      </div>

      <div class="methods-list">
        <div
          class="method-button card"
          pRipple
          (click)="payButtonClick('CC')"
          [class.disabled]="(paymentLoading$ | async) ?? true"
        >
          Paga con carta
          <span class="material-symbols-outlined"> credit_card </span>
        </div>

        <div
          class="method-button gpay"
          pRipple
          (click)="payButtonClick('GOOGLEPAY')"
          [class.disabled]="(paymentLoading$ | async) ?? true"
        >
          Paga con <img src="assets/gpay.png" alt="Google Pay" />
        </div>

        <!-- <div
          class="method-button paypal"
          pRipple
          (click)="payButtonClick('PAYPAL')"
          [class.disabled]="(paymentLoading$ | async) ?? true"
        >
          <img src="assets/paypal.png" alt="PayPal" />
        </div> -->

        <!-- <div
          class="method-button applePay"
          pRipple
          (click)="payButtonClick('APPLEPAY')"
        >
          Paga con <img src="assets/applepay.png" alt="Apple Pay" />
        </div> -->
      </div>

      <div class="sep-line"></div>

      <div class="expiration-section">
        <div class="timer-bar" [class.expired]="payExpRemaining <= 0">
          <div class="bar" [style.width.%]="payExpBarW"></div>
          @if (payExpRemaining > 0) {
            <p class="remaining-time">
              {{ payExpRemaining | duration: { format: "mm:ss" } }}
            </p>
          } @else {
            <p class="remaining-time">
              {{ t("reservationExpired") }}
            </p>
          }
        </div>

        <p class="helper-text">
          @if (payExpRemaining > 0) {
            {{ t("rideReservationExpirationHelper") }}
          } @else {
            {{ t("rideReservationExpiredHelper") }}
          }
        </p>
      </div>

      <p-button
        [label]="t('cancelRide')"
        severity="danger"
        [outlined]="true"
        (click)="cancelRideClick()"
        class="cancel-ride-button"
        [disabled]="(bikeUnlockLoading$ | async) ?? true"
        [loading]="(bikeUnlockLoading$ | async) ?? true"
      />
    </div>
  </ng-template>

  <ng-template #bikeUnlockTmpl>
    <div class="section-card" id="bike-unlock">
      <p class="card-title">{{ t("bikeUnlock") }}</p>
      <p class="unlock-helper-text">{{ t("bikeUnlockHelper") }}</p>

      @if (currentRideData) {
        <div class="station-section">
          <div class="station-item">
            <div class="station-picture">
              @if (currentRideData.startStationDetails?.logoPicture) {
                <img
                  [src]="
                    '/assets/stations/' +
                    currentRideData.startStationDetails?.logoPicture
                  "
                  [alt]="t('stationPicture')"
                />
              } @else {
                <span class="material-symbols-outlined"> location_on </span>
              }
            </div>

            <div class="station-details">
              <h3 class="station-name">
                {{ currentRideData.startStationDetails?.description }}
              </h3>

              <p class="station-address">
                {{
                  getStationAddressString(currentRideData.startStationDetails)
                }}
              </p>
            </div>
          </div>
          <p-button
            [label]="t('getIndications')"
            severity="secondary"
            class="get-indications-button"
            icon="pi pi-directions"
            (click)="
              curWindow.open(
                'https://maps.google.com/?q=' +
                  currentRideData.startStationDetails?.lat +
                  ',' +
                  currentRideData.startStationDetails?.lng,
                '_blank'
              )
            "
          />
        </div>

        <div class="sep-line mt"></div>

        <div class="bike-item">
          <div class="bike-picture">
            @if (currentRideData.bikeIdDetails?.modelDetails?.mainPicture) {
              <img
                [src]="
                  '/assets/bike_models/' +
                  currentRideData.bikeIdDetails?.modelDetails?.mainPicture
                "
                [alt]="t('modelPicture')"
              />
            } @else {
              <span class="material-symbols-outlined"> pedal_bike </span>
            }
          </div>

          <div class="bike-details">
            <h3 class="bike-model-name">
              {{ currentRideData.bikeIdDetails?.progressive ?? "--" }} •
              {{
                currentRideData.bikeIdDetails?.modelDetails?.description ?? "--"
              }}
            </h3>
            <p class="bike-codes">
              {{
                t("identifier") +
                  " #" +
                  (currentRideData.bikeIdDetails?.identifier ??
                    currentRideData.bikeIdDetails?.bikeId)
              }}
            </p>
          </div>
        </div>

        <div class="bike-unlock-section">
          <p-button
            [label]="t('unlockBike')"
            severity="primary"
            class="unlock-bike-button"
            icon="pi pi-lock-open"
            (click)="unlockBikeAndStartClick()"
            [disabled]="
              ((bikeUnlockLoading$ | async) ?? true) ||
              ((bikeIdentifyLoading$ | async) ?? true)
            "
            [loading]="(bikeUnlockLoading$ | async) ?? true"
          />

          <p-button
            [label]="t('identifyBike')"
            severity="help"
            [outlined]="true"
            class="identify-bike-button"
            icon="pi pi-bullseye"
            (click)="identifyBikeClick()"
            [disabled]="
              ((bikeUnlockLoading$ | async) ?? true) ||
              ((bikeIdentifyLoading$ | async) ?? true)
            "
            [loading]="(bikeIdentifyLoading$ | async) ?? true"
          />
        </div>

        <div class="sep-line mb"></div>

        @if (this.currentRideData.tariffPlanDetails?.reservationTimeout) {
          <div class="expiration-section">
            <div class="timer-bar" [class.expired]="unlockExpRemaining <= 0">
              <div class="bar" [style.width.%]="unlockExpBarW"></div>
              @if (unlockExpRemaining > 0) {
                <p class="remaining-time">
                  {{ unlockExpRemaining | duration: { format: "mm:ss" } }}
                </p>
              } @else {
                <p class="remaining-time">
                  {{ t("timeExpired") }}
                </p>
              }
            </div>

            <p class="helper-text">
              @if (unlockExpRemaining > 0) {
                {{
                  t("bikeUnlockTimeoutHelper", {
                    penaltyCost:
                      (this.currentRideData.tariffPlanDetails
                        .reservationPenaltyCost ?? 0) + "€",
                  })
                }}
              } @else {
                {{
                  t("bikeUnlockTimeoutExpiredHelper", {
                    penaltyCost:
                      (this.currentRideData.tariffPlanDetails
                        .reservationPenaltyCost ?? 0) + "€",
                  })
                }}
              }
            </p>
          </div>
        }
      }
    </div>
  </ng-template>

  <ng-template #rideTmpl>
    <div class="section-card" id="ride">
      <p class="card-title">{{ t("manageRide") }}</p>

      @if (!bikePosition || (bikePosition.lat == 0 && bikePosition.lng == 0)) {
        <div class="bike-localization-loading">
          <p-progress-spinner
            strokeWidth="5"
            fill="transparent"
            animationDuration="2s"
            class="bike-localization-spinner"
          />

          <p>{{ t("bikePositionLoading") }}</p>
        </div>
      }

      @if (currentRideData) {
        <div class="ride-details">
          <div class="detail-row">
            <span class="material-symbols-outlined detail-icon">
              schedule
            </span>
            <p class="detail-label">{{ t("duration") }}</p>

            <div class="detail-value-container">
              <p class="detail-value">
                {{
                  currentRideData.elapsedTimeSeconds ?? 0
                    | duration
                      : {
                          format:
                            currentRideData.elapsedTimeSeconds > 3600
                              ? "HH:mm:ss"
                              : "mm:ss",
                        }
                }}
              </p>
            </div>
          </div>

          <!-- <div class="detail-row">
            <span class="material-symbols-outlined detail-icon"> route </span>
            <p class="detail-label">{{ t("distanceTravelled") }}</p>

            <div class="detail-value-container">
              <p class="detail-value">
                @if (currentRideData.iotDetails?.bike?.rideMileage) {
                  {{ currentRideData.iotDetails?.bike?.rideMileage ?? "--" }}
                  km
                } @else {
                  {{ t("notAvailableShort") }}
                }
              </p>
            </div>
          </div>

          <div class="detail-row">
            <span class="material-symbols-outlined detail-icon">
              electric_bike
            </span>
            <p class="detail-label">{{ t("residualAutonomy") }}</p>

            <div class="detail-value-container">
              <p class="detail-value">
                @if (currentRideData.iotDetails?.bike?.battery?.level) {
                  {{
                    currentRideData.iotDetails?.bike?.battery?.level ?? "--"
                  }}% (~
                  {{
                    currentRideData.iotDetails?.bike?.remainingMileage ?? "--"
                  }}
                  km)
                } @else {
                  {{ t("notAvailableShort") }}
                }
              </p>
            </div>
          </div> -->
        </div>

        <div class="sep-line"></div>

        <div
          class="station-item"
          [class.bonus]="currentRideData.startStationDetails.bonus"
        >
          <div class="station-picture departure">
            @if (currentRideData.startStationDetails.logoPicture) {
              <img
                [src]="
                  '/assets/stations/' +
                  currentRideData.startStationDetails.logoPicture
                "
                [alt]="t('stationPicture')"
              />
            } @else {
              <span class="material-symbols-outlined"> play_arrow </span>
            }
          </div>

          <div class="station-details">
            <h3 class="station-name">
              {{ currentRideData.startStationDetails.description }}
            </h3>

            <p class="station-address">
              {{ getStationAddressString(currentRideData.startStationDetails) }}
            </p>
          </div>
        </div>

        <span class="material-symbols-outlined arrow"> south </span>

        <div
          class="station-section"
          [class.bonus]="currentRideData.startStationDetails.bonus"
        >
          <div class="station-item">
            <div class="station-picture arrival">
              @if (currentRideData.endStationDetails.logoPicture) {
                <img
                  [src]="
                    '/assets/stations/' +
                    currentRideData.endStationDetails.logoPicture
                  "
                  [alt]="t('stationPicture')"
                />
              } @else {
                <span class="material-symbols-outlined"> sports_score </span>
              }
            </div>

            <div class="station-details">
              <h3 class="station-name">
                {{ currentRideData.endStationDetails.description }}
              </h3>

              <p class="station-address">
                {{ getStationAddressString(currentRideData.endStationDetails) }}
              </p>
            </div>
          </div>
          <div class="buttons-row">
            <p-button
              [label]="t('directions')"
              severity="secondary"
              class="get-indications-button"
              icon="pi pi-directions"
              (click)="
                curWindow.open(
                  'https://maps.google.com/?q=' +
                    currentRideData.endStationDetails.lat +
                    ',' +
                    currentRideData.endStationDetails.lng,
                  '_blank'
                )
              "
              [disabled]="(bikeUnlockLoading$ | async) ?? true"
            />

            <p-button
              [label]="t('change')"
              severity="secondary"
              class="change-station-button"
              icon="pi pi-pencil"
              (click)="changeArrivalStationBtnClick()"
              [disabled]="
                !bikePosition || ((bikeUnlockLoading$ | async) ?? true)
              "
            />
          </div>
        </div>

        <div class="sep-line"></div>

        <div class="tariff-plan-item">
          <div class="tariff-plan-icon">
            <span class="material-symbols-outlined"> payments </span>
          </div>

          <div class="tariff-plan-details">
            <h3 class="tariff-plan-name">
              {{ currentRideData.tariffPlanDetails.description }}
            </h3>

            <p class="tariff-plan-extra-details">{{ t("tariffPlan") }}</p>
          </div>

          <div
            class="tariff-plan-info-btn"
            (click)="
              $event.preventDefault();
              $event.stopPropagation();
              showTariffPlanInfo(currentRideData.tariffPlanDetails)
            "
          >
            <span class="material-symbols-outlined"> info </span>
          </div>
        </div>

        <div class="sep-line"></div>

        <div class="bike-item">
          <div class="bike-picture">
            @if (currentRideData.bikeIdDetails?.modelDetails?.mainPicture) {
              <img
                [src]="
                  '/assets/bike_models/' +
                  currentRideData.bikeIdDetails?.modelDetails?.mainPicture
                "
                [alt]="t('modelPicture')"
              />
            } @else {
              <span class="material-symbols-outlined"> pedal_bike </span>
            }
          </div>

          <div class="bike-details">
            <h3 class="bike-model-name">
              {{ currentRideData.bikeIdDetails?.progressive }} •
              {{ currentRideData.bikeIdDetails?.modelDetails?.description ?? "--" }}
            </h3>
            <p class="bike-codes">
              {{
                t("identifier") +
                  " #" +
                  (currentRideData.bikeIdDetails?.identifier ?? currentRideData.bikeIdDetails?.bikeId)
              }}
            </p>
          </div>
        </div>

        @if (
          currentRideData.status === "PAUSED" ||
          (currentRideData.iotDetails?.lock?.isLocked ?? false)
        ) {
          <p-button
            [label]="t('unlockBikeAndResume')"
            severity="primary"
            [outlined]="true"
            (click)="unlockBikeClick()"
            class="unlock-bike-button-2"
            icon="pi pi-play"
            [disabled]="(bikeUnlockLoading$ | async) ?? true"
            [loading]="(bikeUnlockLoading$ | async) ?? true"
          />
        } @else {
          <p-button
            [label]="t('pauseRide')"
            severity="warn"
            [outlined]="true"
            (click)="pauseRideClick()"
            class="pause-ride-button"
            icon="pi pi-pause"
            [disabled]="(bikeUnlockLoading$ | async) ?? true"
            [loading]="(bikeUnlockLoading$ | async) ?? true"
          />
        }

        @if (currentRideData.iotDetails?.location?.isCloseToArrival ?? false) {
          <p-button
            [label]="t('terminateRide')"
            severity="danger"
            [outlined]="true"
            (click)="terminateRideClick()"
            class="cancel-ride-button"
            icon="pi pi-stop"
            [disabled]="(bikeUnlockLoading$ | async) ?? true"
            [loading]="(bikeUnlockLoading$ | async) ?? true"
          />
        }
      }
    </div>
  </ng-template>

  <ng-template #changeArrivalStationsListTmpl>
    <div class="section-card" id="arrival-stations-list">
      <p class="card-small-title">
        {{
          currentSearchLocation
            ? t("stationsInSelectedZone")
            : t("stationsNearby")
        }}
      </p>
      <p class="card-title">{{ t("changeArrivalStation") }}</p>

      <div class="actions-container">
        <p-button
          icon="pi pi-refresh"
          styleClass="refresh-button"
          [rounded]="true"
          size="small"
          severity="primary"
          [outlined]="true"
          (click)="refreshChangeArrivalStations()"
          [disabled]="(changeArrivalStationsLoading$ | async) ?? true"
        />

        <p-button
          [label]="t('filters')"
          icon="pi pi-filter"
          styleClass="filter-button"
          [rounded]="true"
          size="small"
          severity="secondary"
          (click)="showChangeArrivalStationsFilters()"
        />

        @if (currentSearchLocation && isGpsAvailable) {
          <p-button
            [label]="t('searchInYourZone')"
            icon="pi pi-bullseye"
            styleClass="change-zone-button"
            [rounded]="true"
            [outlined]="true"
            size="small"
            severity="help"
            (click)="setLockUser(true)"
          />
        } @else {
          <p-button
            [label]="t('searchOnMap')"
            icon="pi pi-map"
            styleClass="search-map-button"
            [rounded]="true"
            [outlined]="true"
            size="small"
            severity="secondary"
            (click)="showAddressSearch()"
          />
        }
      </div>

      <div class="list-container">
        @if ((changeArrivalStationsLoadingUI$ | async) ?? true) {
          @for (i of [1, 2, 3, 4]; track i) {
            <p-skeleton class="skeleton-loader" height="90px" width="100%" />
          }
        } @else {
          @for (station of changeArrivalStations; track station.stationId) {
            <div
              class="station-item"
              pRipple
              (click)="changeArrivalStationClick(station)"
              [class.unavailable]="isArrivalStationUnavailable(station)"
              [class.bonus]="station.bonus"
            >
              <div class="station-picture">
                @if (station.logoPicture) {
                  <img
                    [src]="'/assets/stations/' + station.logoPicture"
                    [alt]="t('stationPicture')"
                  />
                } @else {
                  <span class="material-symbols-outlined"> location_on </span>
                }
              </div>

              <div class="station-details">
                <h3 class="station-name">
                  {{ station.description }}
                </h3>

                <p class="station-times">
                  <span
                    class="open-status"
                    [class.open]="station.open"
                    [class.open-soon]="isOpeningSoon(station)"
                    [class.close-soon]="isClosingSoon(station)"
                    >{{
                      isOpeningSoon(station)
                        ? t("openingSoon")
                        : isClosingSoon(station)
                          ? t("closingSoon")
                          : station.open
                            ? t("open")
                            : t("closed")
                    }}</span
                  >
                  ⋅
                  <span class="time-details">{{
                    getNowOpenTimeSlot(station)
                  }}</span>
                </p>

                <!-- <p class="station-address">
                  {{ getStationAddressString(station) }}
                </p> -->

                <div class="station-info-container">
                  <div
                    class="station-info"
                    [pTooltip]="t('distance')"
                    tooltipPosition="top"
                    [showDelay]="500"
                  >
                    <span class="material-symbols-outlined info-icon">
                      distance
                    </span>
                    <span class="info-value">{{
                      formatDistance(station.distance)
                    }}</span>
                  </div>

                  @if (station.bonus) {
                    <div
                      class="station-info bonus"
                      [pTooltip]="t('bonus')"
                      tooltipPosition="top"
                      [showDelay]="500"
                    >
                      <span class="material-symbols-outlined info-icon">
                        percent
                      </span>
                      <span class="info-value"
                        >{{ t("discount") + " " + station.bonus }}%</span
                      >
                    </div>
                  }
                </div>
              </div>
            </div>

            @if (!$last) {
              <div class="sep-line"></div>
            }
          } @empty {
            <div class="data-placeholder">
              <img
                class="illustration"
                src="assets/no-location.svg"
                [alt]="t('noResults')"
              />
              <h2>{{ t("noStationsFound") }}</h2>
              <p>
                {{
                  stationsLastReturnCode == 200
                    ? t("noStationAvailableInSelectedArea")
                    : t("notFoundChangeParameters")
                }}
              </p>
            </div>
          }
        }
      </div>
    </div>
  </ng-template>

  <!--? STATIONS FILTERS DIALOG --------------------------------->
  <p-dialog
    [header]="t('filterStations')"
    [modal]="true"
    [(visible)]="stationsFiltersDialogVisible"
    [style]="{
      width: 'min(30rem, 90vw)',
    }"
    [maximizable]="false"
    [draggable]="false"
    [dismissableMask]="true"
    [closeOnEscape]="true"
    appendTo="body"
    styleClass="extra-round"
  >
    <div class="stations-filters-form">
      <!--? SEARCH RADIUS ----------------------------->

      <p-floatlabel variant="in">
        <p-inputnumber
          id="searchRadius"
          name="searchRadius"
          [(ngModel)]="tmpStationsFilters.searchRadius"
          autocomplete="off"
          [disabled]="(stationsLoadingUI$ | async) ?? true"
          min="0"
          max="50000"
          [showButtons]="true"
        />
        <label for="searchRadius">
          {{ t("searchRadiusMeters") }}
        </label>
      </p-floatlabel>

      <div class="select-button-float-label">
        <p-selectbutton
          id="openStatus"
          name="openStatus"
          [(ngModel)]="tmpStationsFilters.openStatus"
          autocomplete="off"
          [disabled]="(stationsLoadingUI$ | async) ?? true"
          appendTo="body"
          [options]="[
            { label: t('openFeminine'), value: 'open' },
            { label: t('closedFeminine'), value: 'closed' },
            { label: t('allFeminine'), value: 'all' },
          ]"
          [allowEmpty]="false"
        />
        <label for="openStatus">
          {{ t("status") }}
        </label>
      </div>

      <div class="select-button-float-label">
        <p-selectbutton
          id="bikeAvailability"
          name="bikeAvailability"
          [(ngModel)]="tmpStationsFilters.bikeAvailability"
          autocomplete="off"
          [disabled]="(stationsLoadingUI$ | async) ?? true"
          appendTo="body"
          [options]="[
            { label: t('availablePlural'), value: 'available' },
            { label: t('notAvailablePluralShort'), value: 'notAvailable' },
            { label: t('allFeminine'), value: 'all' },
          ]"
          [allowEmpty]="false"
        />
        <label for="bikeAvailability">
          {{ t("bikes") }}
        </label>
      </div>
    </div>

    <ng-template #footer>
      <p-button
        [label]="t('reset')"
        severity="secondary"
        [outlined]="true"
        (click)="resetStationsFilters()"
        [disabled]="(stationsLoading$ | async) ?? true"
      />
      <p-button
        [label]="t('apply')"
        severity="primary"
        (click)="applyStationsFilters()"
        [disabled]="(stationsLoading$ | async) ?? true"
        [loading]="(stationsLoading$ | async) ?? true"
      />
    </ng-template>
  </p-dialog>

  <!--? ARRIVAL STATIONS FILTERS DIALOG --------------------------------->
  <p-dialog
    [header]="t('filterStations')"
    [modal]="true"
    [(visible)]="arrivalStationsFiltersDialogVisible"
    [style]="{
      width: 'min(30rem, 90vw)',
    }"
    [maximizable]="false"
    [draggable]="false"
    [dismissableMask]="true"
    [closeOnEscape]="true"
    appendTo="body"
    styleClass="extra-round"
  >
    <div class="arrival-stations-filters-form">
      <!--? SEARCH RADIUS ----------------------------->

      <p-floatlabel variant="in">
        <p-inputnumber
          id="searchRadiusArrival"
          name="searchRadius"
          [(ngModel)]="tmpArrivalStationsFilters.searchRadius"
          autocomplete="off"
          [disabled]="(arrivalStationsLoadingUI$ | async) ?? true"
          min="0"
          max="50000"
          [showButtons]="true"
        />
        <label for="searchRadius">
          {{ t("searchRadiusMeters") }}
        </label>
      </p-floatlabel>

      <div class="select-button-float-label">
        <p-selectbutton
          id="openStatusArrival"
          name="openStatus"
          [(ngModel)]="tmpArrivalStationsFilters.openStatus"
          autocomplete="off"
          [disabled]="(arrivalStationsLoadingUI$ | async) ?? true"
          appendTo="body"
          [options]="[
            { label: t('openFeminine'), value: 'open' },
            { label: t('closedFeminine'), value: 'closed' },
            { label: t('allFeminine'), value: 'all' },
          ]"
          [allowEmpty]="false"
        />
        <label for="openStatus">
          {{ t("status") }}
        </label>
      </div>
    </div>

    <ng-template #footer>
      <p-button
        [label]="t('reset')"
        severity="secondary"
        [outlined]="true"
        (click)="resetArrivalStationsFilters()"
        [disabled]="(arrivalStationsLoading$ | async) ?? true"
      />
      <p-button
        [label]="t('apply')"
        severity="primary"
        (click)="applyArrivalStationsFilters()"
        [disabled]="(arrivalStationsLoading$ | async) ?? true"
        [loading]="(arrivalStationsLoading$ | async) ?? true"
      />
    </ng-template>
  </p-dialog>

  <!--? CHANGE ARRIVAL STATIONS FILTERS DIALOG --------------------------------->
  <p-dialog
    [header]="t('filterStations')"
    [modal]="true"
    [(visible)]="changeArrivalStationsFiltersDialogVisible"
    [style]="{
      width: 'min(30rem, 90vw)',
    }"
    [maximizable]="false"
    [draggable]="false"
    [dismissableMask]="true"
    [closeOnEscape]="true"
    appendTo="body"
    styleClass="extra-round"
  >
    <div class="arrival-stations-filters-form">
      <!--? SEARCH RADIUS ----------------------------->

      <p-floatlabel variant="in">
        <p-inputnumber
          id="searchRadiusChangeArrival"
          name="searchRadius"
          [(ngModel)]="tmpChangeArrivalStationsFilters.searchRadius"
          autocomplete="off"
          [disabled]="(changeArrivalStationsLoadingUI$ | async) ?? true"
          min="0"
          max="50000"
          [showButtons]="true"
        />
        <label for="searchRadius">
          {{ t("searchRadiusMeters") }}
        </label>
      </p-floatlabel>

      <div class="select-button-float-label">
        <p-selectbutton
          id="openStatusChangeArrival"
          name="openStatus"
          [(ngModel)]="tmpChangeArrivalStationsFilters.openStatus"
          autocomplete="off"
          [disabled]="(changeArrivalStationsLoadingUI$ | async) ?? true"
          appendTo="body"
          [options]="[
            { label: t('openFeminine'), value: 'open' },
            { label: t('closedFeminine'), value: 'closed' },
            { label: t('allFeminine'), value: 'all' },
          ]"
          [allowEmpty]="false"
        />
        <label for="openStatus">
          {{ t("status") }}
        </label>
      </div>
    </div>

    <ng-template #footer>
      <p-button
        [label]="t('reset')"
        severity="secondary"
        [outlined]="true"
        (click)="resetChangeArrivalStationsFilters()"
        [disabled]="(changeArrivalStationsLoading$ | async) ?? true"
      />
      <p-button
        [label]="t('apply')"
        severity="primary"
        (click)="applyChangeArrivalStationsFilters()"
        [disabled]="(changeArrivalStationsLoading$ | async) ?? true"
        [loading]="(changeArrivalStationsLoading$ | async) ?? true"
      />
    </ng-template>
  </p-dialog>

  <!--? SEARCH ADDRESS DIALOG --------------------------------->
  <p-dialog
    [header]="t('searchOnMap')"
    [modal]="true"
    [(visible)]="mapAddressSearchDialogVisible"
    [style]="{
      width: 'min(30rem, 90vw)',
      height: 'clamp(25rem, 90dvh, 42rem)',
    }"
    [maximizable]="false"
    [draggable]="false"
    [dismissableMask]="true"
    [closeOnEscape]="true"
    [focusOnShow]="true"
    [focusTrap]="true"
    appendTo="body"
    styleClass="extra-round search-map-dialog"
    (onHide)="onMapAddressSearchHide(searchAddressInput)"
    (onShow)="onMapAddressSearchShow(searchAddressInput)"
  >
    <div class="address-search-body">
      <p-floatlabel variant="in">
        <input
          #searchAddressInput
          pInputText
          id="searchAddressInput"
          (input)="onAddressSearch($event)"
          autocomplete="off"
          tabindex="0"
        />
        <label for="searchAddressInput">
          {{ t("searchByAddressCity") }}
        </label>
      </p-floatlabel>

      @if ((mapAddressSearchResultsLoading$ | async) ?? true) {
        <div class="results-list">
          @for (i of [1, 2, 3, 4]; track i) {
            <p-skeleton
              class="skeleton-loader no-padding"
              height="100%"
              width="100%"
            />
          }
        </div>
      } @else {
        @if (mapAddressSearchResults.length > 0) {
          <div class="results-list">
            @for (location of mapAddressSearchResults; track $index) {
              <div
                class="search-result"
                pRipple
                (click)="onLocationSelected(location)"
              >
                <div class="place-icon">
                  <span class="material-symbols-outlined">
                    {{ getPlaceIcon(location) }}
                  </span>
                </div>
                <p class="place-name">{{ location.display_name }}</p>
              </div>
            }
          </div>
        } @else {
          @if (mapAddressSearchQuery.length > 2) {
            <div class="data-placeholder">
              <img
                class="illustration"
                src="assets/no-location.svg"
                [alt]="t('noResults')"
              />
              <h2>{{ t("noResultFound") }}</h2>
              <p>
                {{ t("notFoundChangeParameters") }}
              </p>
            </div>
          } @else {
            <div class="data-placeholder">
              <img
                class="illustration"
                src="assets/no-location.svg"
                [alt]="t('noResults')"
              />
              <p class="helper">
                {{ t("searchOnMapDescription") }}
              </p>
            </div>
          }
        }
      }
    </div>
  </p-dialog>

  <!--? TARIFF PLAN DIALOG --------------------------------->
  <p-dialog
    [header]="t('tariffPlanDetails', { name: tariffPlanInfo?.description })"
    [modal]="true"
    [(visible)]="tariffPlanDialogVisible"
    [style]="{
      width: 'min(32rem, 90vw)',
      'max-height': '80dvh',
    }"
    [maximizable]="false"
    [draggable]="false"
    [dismissableMask]="true"
    [closeOnEscape]="true"
    [autofocus]="false"
    appendTo="body"
    [maskStyle]="{ 'backdrop-filter': 'blur(10px)' }"
    styleClass="extra-round tariff-plan-dialog"
  >
    @if (tariffPlanInfo) {
      @if (tariffPlanInfo.details) {
        <p class="tariff-plan-details-text">{{ tariffPlanInfo.details }}</p>
      }
      <div class="tariff-plan-details-list">
        <div class="detail-row">
          <span class="material-symbols-outlined detail-icon"> lock_open </span>
          <p class="detail-label">{{ t("unlockCost") }}</p>

          <div class="detail-value-container">
            <p class="detail-value">
              {{
                tariffPlanInfo.unlockCost
                  ? tariffPlanInfo.unlockCost + " €"
                  : "Gratis"
              }}
            </p>
          </div>
        </div>

        @if (tariffPlanInfo.pauseCost) {
          <div class="detail-row">
            <span class="material-symbols-outlined detail-icon"> pause </span>
            <p class="detail-label">{{ t("pauseCost") }}</p>

            <div class="detail-value-container">
              <p class="detail-value">{{ tariffPlanInfo.pauseCost }} €/min</p>
            </div>
          </div>
        }

        @if (tariffPlanInfo.kmCost) {
          <div class="detail-row">
            <span class="material-symbols-outlined detail-icon"> laps </span>
            <p class="detail-label">{{ t("costPerKilometer") }}</p>

            <div class="detail-value-container">
              <p class="detail-value">{{ tariffPlanInfo.kmCost }} €/km</p>
            </div>
          </div>

          @if (tariffPlanInfo.freeKm) {
            <div class="detail-row green">
              <span class="material-symbols-outlined detail-icon"> sell </span>
              <p class="detail-label">{{ t("freeKm") }}</p>

              <div class="detail-value-container">
                <p class="detail-value">{{ tariffPlanInfo.freeKm }} km</p>
              </div>
            </div>
          }
        } @else if (tariffPlanInfo.minCost) {
          <div class="detail-row">
            <span class="material-symbols-outlined detail-icon"> laps </span>
            <p class="detail-label">{{ t("costPerMinute") }}</p>

            <div class="detail-value-container">
              <p class="detail-value">{{ tariffPlanInfo.minCost }} €/min</p>
            </div>
          </div>

          @if (tariffPlanInfo.freeMins) {
            <div class="detail-row green">
              <span class="material-symbols-outlined detail-icon"> sell </span>
              <p class="detail-label">{{ t("freeMins") }}</p>

              <div class="detail-value-container">
                <p class="detail-value">{{ tariffPlanInfo.freeMins }} min</p>
              </div>
            </div>
          }
        }

        @if (tariffPlanInfo.reservationTimeout) {
          <div class="detail-row">
            <span class="material-symbols-outlined detail-icon">
              hourglass
            </span>
            <p class="detail-label">{{ t("reservationTimeout") }}</p>

            <div class="detail-value-container">
              <p class="detail-value">
                {{ tariffPlanInfo.reservationTimeout }} min
              </p>
            </div>
          </div>

          @if (tariffPlanInfo.reservationPenaltyCost) {
            <div class="detail-row amber">
              <span class="material-symbols-outlined detail-icon">
                running_with_errors
              </span>
              <p class="detail-label">{{ t("reservationPenaltyCost") }}</p>

              <div class="detail-value-container">
                <p class="detail-value">
                  {{ tariffPlanInfo.reservationPenaltyCost }} €
                </p>
              </div>
            </div>
          }
        }

        @if (tariffPlanInfo.maxRideDuration) {
          <div class="detail-row">
            <span class="material-symbols-outlined detail-icon">
              schedule
            </span>
            <p class="detail-label">{{ t("maxRideDuration") }}</p>

            <div class="detail-value-container">
              <p class="detail-value">
                {{ tariffPlanInfo.maxRideDuration }} min
              </p>
            </div>
          </div>

          @if (tariffPlanInfo.extraMinutePenaltyCost) {
            <div class="detail-row amber">
              <span class="material-symbols-outlined detail-icon"> error </span>
              <p class="detail-label">{{ t("extraMinutePenaltyCost") }}</p>

              <div class="detail-value-container">
                <p class="detail-value">
                  {{ tariffPlanInfo.extraMinutePenaltyCost }} €/min
                </p>
              </div>
            </div>
          }
        }

        @if (tariffPlanInfo.maxRideDistance) {
          <div class="detail-row">
            <span class="material-symbols-outlined detail-icon"> route </span>
            <p class="detail-label">{{ t("maxRideDistance") }}</p>

            <div class="detail-value-container">
              <p class="detail-value">
                {{ tariffPlanInfo.maxRideDistance }} km
              </p>
            </div>
          </div>

          @if (tariffPlanInfo.extraKmPenaltyCost) {
            <div class="detail-row amber">
              <span class="material-symbols-outlined detail-icon"> error </span>
              <p class="detail-label">{{ t("extraKmPenaltyCost") }}</p>

              <div class="detail-value-container">
                <p class="detail-value">
                  {{ tariffPlanInfo.extraKmPenaltyCost }} €/km
                </p>
              </div>
            </div>
          }
        }

        @if (tariffPlanInfo.minPrice) {
          <div class="detail-row">
            <span class="material-symbols-outlined detail-icon">
              keyboard_arrow_down
            </span>
            <p class="detail-label">{{ t("minPrice") }}</p>

            <div class="detail-value-container">
              <p class="detail-value">{{ tariffPlanInfo.minPrice }} €</p>
            </div>
          </div>
        }

        @if (tariffPlanInfo.maxPrice) {
          <div class="detail-row">
            <span class="material-symbols-outlined detail-icon">
              keyboard_arrow_up
            </span>
            <p class="detail-label">{{ t("maxPrice") }}</p>

            <div class="detail-value-container">
              <p class="detail-value">{{ tariffPlanInfo.maxPrice }} €</p>
            </div>
          </div>
        }
      </div>
    }

    <ng-template #footer>
      <p-button
        [label]="t('close')"
        severity="secondary"
        [outlined]="true"
        (click)="hideTariffPlanInfo()"
      />
    </ng-template>
  </p-dialog>

  <!--? REPORT DIALOG --------------------------------->
  <p-dialog
    [header]="t('makeReport')"
    [modal]="true"
    [(visible)]="reportDialogVisible"
    [style]="{
      width: 'min(32rem, 90vw)',
      'max-height': '80dvh',
    }"
    [maximizable]="false"
    [draggable]="false"
    [dismissableMask]="true"
    [closeOnEscape]="true"
    [autofocus]="false"
    appendTo="body"
    styleClass="extra-round report-dialog"
    [maskStyle]="{ 'backdrop-filter': 'blur(10px)' }"
    (onHide)="reportForm.reset()"
  >
    <form #reportForm="ngForm" class="report-form">
      <!--? CATEGORY ---------------------------->
      <p-floatlabel variant="in">
        <p-select
          #reportCategoryInput="ngModel"
          inputId="report-category-input"
          name="reportCategory"
          [(ngModel)]="currentReportData.category"
          autocomplete="off"
          [options]="currentReportCategoryOptions"
          appendTo="body"
          styleClass="w-full"
          [showClear]="true"
          optionLabel="label"
          optionValue="id"
          required
        />
        <label for="report-category-input">
          {{ t("category") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>

      <!--? DETAILS ---------------------------------->
      <p-floatlabel variant="in">
        <textarea
          pTextarea
          #reportDetailsInput="ngModel"
          id="report-details-input"
          name="reportDetails"
          [(ngModel)]="currentReportData.details"
          autocomplete="off"
          styleClass="w-full"
          rows="4"
          style="resize: none"
          [required]="isReportDetailsRequired"
        ></textarea>
        <label for="report-details-input">
          {{ t("details") }}
          @if (isReportDetailsRequired) {
            <span class="mandatory-label">*</span>
          }
        </label>
      </p-floatlabel>
    </form>

    <ng-template #footer>
      <p-button
        [label]="t('cancel')"
        severity="secondary"
        [outlined]="true"
        (click)="hideReportDialog()"
      />

      <p-button
        [label]="t('send')"
        severity="primary"
        (click)="submitReportButtonClick()"
        [disabled]="reportForm.invalid"
      />
    </ng-template>
  </p-dialog>

  <!--? CONNECTION ERROR DIALOG --------------------------------->
  <p-dialog
    [header]="t('errors.connectionLost')"
    [modal]="true"
    [(visible)]="connectionErrorDialogVisible"
    [style]="{
      width: 'min(35rem, 90vw)',
    }"
    [maximizable]="false"
    [draggable]="false"
    [dismissableMask]="false"
    [closeOnEscape]="false"
    [closable]="false"
    [autofocus]="false"
    appendTo="body"
    styleClass="extra-round connection-error-dialog"
    [maskStyle]="{ 'backdrop-filter': 'blur(10px)' }"
  >
    <div class="connection-error-dialog-content">
      <p-progress-spinner
        strokeWidth="5"
        fill="transparent"
        animationDuration="2s"
        class="connection-lost-spinner"
      />
      <p>{{ t("iotConnectionLostMessage") }}</p>
    </div>
  </p-dialog>

  <!--? LOCK ACTION DIALOG --------------------------------->
  <p-dialog
    [header]="t(lockActionDialog.title)"
    [modal]="true"
    [(visible)]="lockActionDialog.visible"
    [style]="{
      width: 'min(35rem, 90vw)',
    }"
    [maximizable]="false"
    [draggable]="false"
    [dismissableMask]="false"
    [closeOnEscape]="false"
    [closable]="false"
    [autofocus]="false"
    appendTo="body"
    styleClass="extra-round lock-action-dialog"
    [maskStyle]="{ 'backdrop-filter': 'blur(10px)' }"
  >
    <div class="lock-action-dialog-content">
      <img src="assets/lock_close.gif" alt="Chiudi lucchetto" />

      <p>{{ t(lockActionDialog.message) }}</p>
    </div>

    <ng-template #footer>
      <p-button
        [label]="t('cancel')"
        severity="secondary"
        [outlined]="true"
        (click)="lockActionDialog.visible = false"
      />
    </ng-template>
  </p-dialog>
</ng-container>
